import { createAsyncThunk } from '@reduxjs/toolkit';
import { IUser } from '@ddot/AddToCartCommon/lib/entities';

import { AsyncThunkAPI } from 'Redux/types';
import NavActions from 'Services/Navigation/Actions';
import Actions from 'Redux/Actions';
import Utils from 'Lib/Utils';
import { string } from 'prop-types';
import Atc from '../../../../Lib/ATC';

import { ErrorTypes } from '.';

interface GetUserInfoParams {
    authToken: string;
}

export default createAsyncThunk<
    string | null,
    GetUserInfoParams,
    AsyncThunkAPI
>('user/getUserIP', async (params, thunkAPI) => {
    // const { authToken } = params;

    const authToken = Utils.Auth.getAuthToken() as string;

    const response = await thunkAPI.extra.useCases.user.getUserIP.execute({ authToken });

    if (response.status === Atc.UseCases.Types.UseCaseResponseStatus.Success) {
        return response.data;
    }
    if (response.data.type === ErrorTypes.GetUserIPError.UserNotFound) {
        return thunkAPI.rejectWithValue(response.data.title || 'User not found!');
    }

    return thunkAPI.rejectWithValue('Something went wrong. Please try again.');
});
